import { FlowContextSme } from '../context';
import { energyTypeIncludes } from '../helpers';
import { EnergyType } from '../types';

export const shouldSkipWhenNoElectricity = (context: FlowContextSme): boolean => {
  const { energyType } = context;

  if (energyType) {
    return !energyTypeIncludes(energyType, EnergyType.Electricity);
  }

  return true;
};
